import axios from "axios"
const request = (method, path, data, params) => axios({ method, url: "/api/contract-workspace/upgrades" + path, data, params, headers: { Authorization: localStorage.getItem("token") } }).then(response => response.data)
export default {
  context: (studioId, userId) => request("get", "/context", null, { studioId, userId }),
  prepare: data => request("post", "/prepare", data),
  quote: data => request("post", "/quotes", data),
  create: data => request("post", "/agreements", data),
  update: (id, data) => request("put", "/agreements/" + encodeURIComponent(id), data),
}
